module.exports = __webpack_public_path__ + "img/classic_thumbnail-600x450.d1150a7f.jpg";